import { getReportTagUsage } from '@/lib/api/report-tags';
import { useQuery } from '@tanstack/react-query';
/**
 * Tags in use across the caller's visible studies, most-used first, for the
 * sidebar's clinical-tags nav. One generous fetch (the org vocabularies are
 * tens of tags, not thousands) — the nav fuzzy-filters client-side so typing
 * costs nothing.
 */
export function useReportTagUsage(enabled = true) {
    const { data, isLoading } = useQuery({
        queryKey: ['report-tag-usage'],
        queryFn: () => getReportTagUsage(undefined, 200),
        enabled,
        staleTime: 60_000,
    });
    return { tags: data ?? [], isLoading };
}
